import React from "react";
import { View, Animated, StyleSheet } from "react-native";
import { AppColors } from "../utility/AppColors";

interface CustomProgressBarProps {
  currentStep: number; // 0 to 5
}

const CustomProgressBar: React.FC<CustomProgressBarProps> = ({
  currentStep,
}) => {
  const progressValue = Math.min(currentStep / 5, 1); // Ensure between 0 to 1
  const progressAnim = new Animated.Value(progressValue);

  Animated.timing(progressAnim, {
    toValue: progressValue,
    duration: 500,
    useNativeDriver: false,
  }).start();

  return (
    <View style={styles.progressBar}>
      <Animated.View
        style={[
          styles.progressFill,
          {
            width: progressAnim.interpolate({
              inputRange: [0, 1],
              outputRange: ["0%", "100%"],
            }),
          },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  progressBar: {
    width: "100%",
    height: 7,
    backgroundColor: AppColors.white, // Background color
    borderRadius: 38,
    overflow: "hidden",
    justifyContent: "center",
    paddingHorizontal: 3,
  },
  progressFill: {
    height: 5,
    backgroundColor: AppColors.purple_453B50, // Filled progress color
    borderRadius: 38,
  },
});

export default CustomProgressBar;
